module.exports = __webpack_public_path__ + "img/OBUHaveOrder_01.e7f187e7.png";